(function ($) {
    var resizeTimer;
  
    function isMobile() {
      // below 991px to match bp($bp-lg)
      return window.matchMedia('(max-width: 990.98px)').matches;
    }
  
    function initIconAccordion() {
      var $wrap = $('.icon-accordion');
      if (!$wrap.length) return;
  
      // target the actual child blocks
      var $items = $wrap.find('> .block-card-icon');
  
      if (isMobile()) {
        $items.removeClass('is-open').first().addClass('is-open');
  
        $items.each(function () {
          var $item = $(this);
          var $title  = $item.find('.title');
          var $toggle = $item.find('.toggle-icon');
  
          $title.off('click.iconAcc').on('click.iconAcc', function () {
            toggleItem($wrap, $item);
          });
  
          $toggle.off('click.iconAcc').on('click.iconAcc', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleItem($wrap, $item);
          });
        });
      } else {
        $items.removeClass('is-open');
        $items.find('.title, .toggle-icon').off('click.iconAcc');
      }
    }
  
    function toggleItem($wrap, $item) {
      var alreadyOpen = $item.hasClass('is-open');
      $wrap.find('> .block-card-icon.is-open').removeClass('is-open');
      if (!alreadyOpen) $item.addClass('is-open');
    }
  
    $(document).ready(initIconAccordion);
  
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initIconAccordion, 150);
    });
  })(jQuery);
  